


























































import Vue from 'vue';
import { mapActions } from 'vuex';
import { get } from 'vuex-pathify';
import { Quote } from '@/models/quote';
import ErrorAlert from '../common/ErrorAlert.vue';
import { ErrorManager } from '@/models/error';

import moment from 'moment';
import { Transition } from '@/models/transition';
import ALDialog from '../core/Dialog/ALDialog.vue';

export default Vue.extend({
  components: { ErrorAlert, ALDialog },

  data: () => ({
    valid: false as boolean,
    dialog: false as boolean,
    loading: false as boolean,

    errorMessage: '',
    detailErrorMessage: '',

    headers: [
      {
        text: 'Date',
        align: 'start',
        sortable: false,
        value: 'timestamp'
      },
      {
        text: 'Changed By',
        align: 'start',
        sortable: false,
        value: 'user'
      },
      {
        text: 'Previous State',
        align: 'center',
        sortable: false,
        value: 'source_state'
      },
      {
        text: 'Current State',
        align: 'center',
        sortable: false,
        value: 'state'
      }
    ]
  }),

  computed: {
    quoteActivities: get<Transition[]>('quote/quoteActivities')
  },

  methods: {
    moment,

    ...mapActions({
      fetchQuoteActivities: 'quote/fetchQuoteActivities'
    }),

    clearAllErrors(): void {
      this.errorMessage = '';
      this.detailErrorMessage = '';
    },

    open(quote: Quote) {
      this.clearAllErrors();

      this.dialog = true;
      this.loading = true;

      this.fetchQuoteActivities({
        quoteId: quote.number,
        revisionId: quote.revision
      })
        .catch(error => {
          if (error.response) {
            if (error.response.data.detail) {
              this.detailErrorMessage = error.response.data.detail;
            }
          }
          this.errorMessage = ErrorManager.extractApiError(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    close() {
      this.dialog = false;
    }
  }
});
